import * as React from 'react';

import { Badge, cn } from '@rematter/ui-web';
import { ThemeColor } from '@rematter/ui-web/types';

import { useTranslations } from '../../i18n/useTranslations';
import { AutomationStatus } from '../../types';

type AutomationStatusBadgeProps = {
  status: AutomationStatus;
  size?: 'small' | 'xs' | 'default' | 'large';
  className?: string;
};

const statusColorMap: Record<AutomationStatus, ThemeColor> = {
  Draft: 'neutral',
  Active: 'success',
  Paused: 'warning',
  Archived: 'neutral',
};

export const AutomationStatusBadge: React.FC<AutomationStatusBadgeProps> = ({
  status,
  size = 'small',
  className,
}) => {
  const t = useTranslations();
  const color = statusColorMap[status];

  return (
    <Badge
      color={color}
      size={size}
      className={cn('@AutomationStatusBadge', className)}
    >
      {t.status[status]}
    </Badge>
  );
};
